'use client'

import { authClient } from '@/lib/auth/auth-client'
import { IconLogout } from '@tabler/icons-react'
import { useRouter } from 'next/navigation'

interface Props {
  className?: string
  label?: string
}

export const SignOut = ({ className, label }: Props) => {
  const router = useRouter()

  const handleSignOut = async () => {
    await authClient.signOut({
      fetchOptions: {
        onSuccess: () => {
          router.refresh()
        },
        onError: (ctx) => {
          alert(ctx.error.message)
        }
      }
    })
  }

  return (
    <button className={`${className}`} onClick={handleSignOut}>
      <IconLogout stroke={2} />
      {label}
    </button>
  )
}
